/**
 * The scanner webview slides in from the left screen edge.
 * @type {string}
 */export var SCANNER_ANIMATION_FOREGROUND_LEFT='foregroundLeft';/**
 * The scanner webview slides in from the right screen edge.
 * @type {string}
 */export var SCANNER_ANIMATION_FOREGROUND_RIGHT='foregroundRight';/**
 * The scanner webview slides in from the bottom screen edge.
 * @type {string}
 */export var SCANNER_ANIMATION_FOREGROUND_BOTTOM='foregroundBottom';/**
 * The scanner webview just appears without animation.
 * @type {string}
 */export var SCANNER_ANIMATION_NONE='';/**
 * The scanner mode option for an active scanner functionality.
 * @type {string}
 */export var SCANNER_MODE_ON='on';/**
 * The scanner mode option for an inactive scanner functionality.
 * @type {string}
 */export var SCANNER_MODE_OFF='off';/**
 * The barcode recognition scanner mode.
 * @type {string}
 */export var SCANNER_TYPE_BARCODE='barcodeRecognition';/**
 * The card recognition scanner mode.
 * @type {string}
 */export var SCANNER_TYPE_CARD='cardRecognition';/**
 * The image recognition scanner mode.
 * @type {string}
 */export var SCANNER_TYPE_IMAGE='imageCapturing';/**
 * Default scope for all scanner formats.
 * @type {string}
 */export var SCANNER_SCOPE_DEFAULT='default';export var SCANNER_MIN_APP_LIB_VERSION='21.0';